import React from 'react';
import styled from 'styled-components';
import {useTranslations} from "use-intl";

import BreadCrumb from '@/components/BreadCrumb';
import { BreadCrumbType } from '@/typings/common';
import { PostFull } from '@/typings/model';

type Props = {
  urlAlias?: string;
  pageName?: string;
};

const Top = ({ urlAlias, pageName }: Props) => {
  const t = useTranslations();
  const breadCrumbList: BreadCrumbType[] = [
    {
      label: t('blog.title'),
      url: '/blog',
    },
    {
      label: pageName,
      url: urlAlias,
    },
  ];

  return (
    <Component>
      <BreadCrumb breadCrumbs={breadCrumbList} />
    </Component>
  );
};

export default Top;
const Component = styled.div``;
